<template>

  <div class="controls-wrapper">
    <l-control position="topleft">
      <div class="controls d-flex flex-column">
        <v-btn x-small color="white" @click="openFilters()" :title="$t('map.controls.filters')">
          <font-awesome-layers>
            <font-awesome-icon icon="filter" size="lg"></font-awesome-icon>
            <font-awesome-layers-text counter v-if="filtersCount" :value="filtersCount" transform="shrink-2 right-25" />
          </font-awesome-layers>
        </v-btn>
      </div>
    </l-control>

    <l-control position="topleft">
      <div class="controls d-flex flex-column">
        <v-btn x-small color="white" @click="$emit('zoom', 1)" :title="$t('map.controls.zoom-in')">
          <font-awesome-icon icon="plus" size="lg"></font-awesome-icon>
        </v-btn>

        <v-btn x-small color="white" @click="$emit('zoom', -1)" :title="$t('map.controls.zoom-out')">
          <font-awesome-icon icon="minus" size="lg"></font-awesome-icon>
        </v-btn>
      </div>
    </l-control>

    <l-control position="topleft">
      <div class="controls d-flex flex-column">
        <v-btn x-small color="white" @click="lock(!locked)" :title="$t('map.controls.' + (locked ? 'unlock' : 'lock'))">
          <font-awesome-icon :icon="lockicon" size="lg"></font-awesome-icon>
        </v-btn>
      </div>
    </l-control>

    <l-control position="topleft">
      <div class="controls d-flex flex-column">
        <v-btn x-small color="white"
               :disabled="locked"
               :class="{ selected: !tool }"
               :title="$t('map.controls.select')"
               @click="select(null)">
          <font-awesome-icon icon="mouse-pointer" transform="grow-10"></font-awesome-icon>
        </v-btn>

        <v-btn x-small color="white"
               :disabled="locked"
               :class="{ selected: tool === 'marker' }"
               :title="$t('map.controls.add-marker')"
               @click="select('marker')">
          <font-awesome-layers>
            <font-awesome-icon icon="map-marker" transform="grow-10"></font-awesome-icon>
            <font-awesome-icon icon="plus" inverse transform="shrink-2 up-2"></font-awesome-icon>
          </font-awesome-layers>
        </v-btn>

        <v-btn x-small color="white"
               :disabled="locked"
               :class="{ selected: tool === 'polygon' }"
               :title="$t('map.controls.add-polygon')"
               @click="select('polygon')">
          <font-awesome-layers>
            <font-awesome-icon icon="draw-polygon" transform="grow-15"></font-awesome-icon>
          </font-awesome-layers>
        </v-btn>

        <v-btn x-small color="white"
               :disabled="locked"
               :class="{ selected: tool === 'polyline' }"
               :title="$t('map.controls.add-polyline')"
               @click="select( 'polyline')">
          <font-awesome-icon icon="bezier-curve" transform="grow-10"></font-awesome-icon>
        </v-btn>

        <v-btn x-small color="white"
               :disabled="locked"
               :class="{ selected: tool === 'rectangle' }"
               :title="$t('map.controls.add-rectangle')"
               @click="select('rectangle')">
          <font-awesome-layers>
            <font-awesome-icon icon="vector-square" transform="grow-10"></font-awesome-icon>
            <font-awesome-icon icon="plus" transform="shrink-3"></font-awesome-icon>
          </font-awesome-layers>
        </v-btn>

        <v-btn x-small color="white"
               :disabled="locked"
               :class="{ selected: tool === 'circle' }"
               :title="$t('map.controls.add-circle')"
               @click="select( 'circle')">
          <font-awesome-layers>
            <font-awesome-icon icon="circle-notch" transform="grow-10"></font-awesome-icon>
            <font-awesome-icon icon="square" transform="shrink-8 up-10"></font-awesome-icon>
            <font-awesome-icon icon="plus" transform="shrink-3"></font-awesome-icon>
          </font-awesome-layers>

        </v-btn>
      </div>
    </l-control>
  </div>

</template>

<script>

import { mapState, mapActions } from "vuex"
import { LControl } from "vue2-leaflet"
import FilterDialog from "../dialogs/filter-dialog"

export default {
  name: 'map-controls',

  props: [ 'tool', 'filter' ],

  data () {
    return {

    }
  },

  computed: {
    ...mapState('map', [
      'locked'
    ]),

    lockicon () {
      return this.locked ? 'lock' : 'lock-open'
    },

    filtersCount () {
      return Object.values(this.filter).filter(x => !!x).length
    }
  },

  methods: {
    ...mapActions('map', {
      _lock: 'lock'
    }),

    select (tool) {
      this.$emit('tool', tool)
    },

    lock (state) {
      this._lock(state)
      this.$emit('locked', state)
    },

    async openFilters () {
      const result = await this.$dialog.showAndWait(FilterDialog, { filter: this.filter })

      if (result)
        this.$emit('filter', result)
    }
  },

  created () {
    this.lock(true)
  },

  components: {
    FilterDialog,
    LControl
  }
}

</script>

<style lang="scss" scoped>

@import '../../../assets/variables';

.controls {
  .v-btn {

    width: $map-control-size;
    height: $map-control-size;
    border-radius: 0;


    &:first-child {
      border-top-left-radius: $map-control-radius;
      border-top-right-radius: $map-control-radius;
    }

    &:last-child {
      border-bottom-left-radius: $map-control-radius;
      border-bottom-right-radius: $map-control-radius;
    }

    svg path{
      fill: $color-primary;
    }

    .v-icon {
      color: $color-primary;
    }

    svg.fa-inverse path {
      fill: white;
    }

    &.selected {
      background-color: #EAEAEA !important;
    }
  }
}

</style>
